import api from './api';

export const appointmentService = {
  // Get all appointments for patient
  getMyAppointments: () => api.get('/appointments'),
  
  // Get appointment by ID
  getAppointment: (id) => api.get(`/appointments/${id}`),
  
  // Book appointment
  bookAppointment: (data) => api.post('/appointments', data),
  
  // Cancel appointment
  cancelAppointment: (id) => api.put(`/appointments/${id}/cancel`),
  
  // Get available time slots
  getAvailableSlots: (doctorId, date) => 
    api.get(`/appointments/available-slots`, { params: { doctor_id: doctorId, date } }),
  
  // Get doctors by department
  getDoctorsByDepartment: (departmentId) => 
    api.get(`/doctors`, { params: { department_id: departmentId } }),
};
